import React, { useState } from 'react';
import ReactDOM from "react-dom";
import {QUOTE_PAGES} from "../JobQuotePage";
import JobOrderCreateEditPage from "../JobOrderCreateEditPage";
import JobOrderShowPage from "../JobOrderShowPage";

export const ORDER_PAGES = {
    INDEX:  'index',
    EDIT:   'edit',
}

const JobOrderPage = (props) => {
    const {
        jobId       = null,
        orderId     = null,
        page        = ORDER_PAGES.INDEX,
        parentId    = "",
    } = props;

    const [currentPage, setCurrentPage]             = useState(page);
    const [selectedJobOrder, setSelectedJobOrder]   = useState(!!orderId ? {id: orderId} : null);

    const handleChangePage = (page, order) => {
        switch (page) {
            case ORDER_PAGES.INDEX:
                window.history.pushState({}, '', route('job.order.index', {job: jobId}).toString());
                break;
            case ORDER_PAGES.EDIT:
                window.history.pushState({}, '', route('job.order.edit', {job: jobId, order: order.id}).toString());
                break;
        }

        setCurrentPage(page);
        setSelectedJobOrder(order);
    }

    switch (currentPage) {
        case QUOTE_PAGES.EDIT:
            return (
                <JobOrderCreateEditPage
                    jobId={jobId}
                    orderId={!!selectedJobOrder && !!selectedJobOrder.id ? selectedJobOrder.id : null}
                    onChangePage={(page, order) => handleChangePage(page, order)}
                    parentId={parentId}
                />
            );
        case ORDER_PAGES.INDEX:
        default:
            return (
                <JobOrderShowPage
                    jobId={jobId}
                    orderId={!!selectedJobOrder && !!selectedJobOrder.id ? selectedJobOrder.id : null}
                    onChangePage={(page, order) => handleChangePage(page, order)}
                    parentId={parentId}
                />
            )
    }
}

export default JobOrderPage;

const target = document.getElementById('job-order-page');
if (target) {
    const {
        jobId       = null,
        orderId     = null,
        page        = ORDER_PAGES.INDEX,
        parentId    = 'job-order-page'
    } = target.dataset;

    ReactDOM.render(
        <JobOrderPage
            jobId={jobId}
            orderId={!!orderId ? orderId : null}
            page={page}
            parentId={parentId}
        />
    , target);
}

